import {Timer} from '@mui/icons-material';
import {Box, Chip, LinearProgress, Paper, Typography} from '@mui/material';
import {QuizTimedMode} from '@cp/model';

export interface SessionPageHeaderProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  progress: number;
  timedMode: QuizTimedMode;
  timeRemaining: number;
  totalTimeRemaining: number;
}

export default function SessionPageHeader({
  currentQuestionIndex,
  totalQuestions,
  progress,
  timedMode,
  timeRemaining,
  totalTimeRemaining,
}: SessionPageHeaderProps) {
  return (
    <Paper sx={{p: 3}}>
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2}}>
        <Typography variant="h5" sx={{fontWeight: 600}}>
          Study Session
        </Typography>
        <Chip label={`Question ${currentQuestionIndex + 1} of ${totalQuestions}`} color="primary" variant="outlined" />
      </Box>

      {/* Progress Bar */}
      <LinearProgress variant="determinate" value={progress} sx={{height: 8, borderRadius: 4}} />

      {/* Timer Display */}
      {timedMode === QuizTimedMode.TIMED_PER_QUESTION && (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mt: 2}}>
          <Timer color="primary" />
          <Typography variant="body2" color="primary">
            Question Time: {Math.floor(timeRemaining / 60)}:{(timeRemaining % 60).toString().padStart(2, '0')}
          </Typography>
        </Box>
      )}

      {timedMode === QuizTimedMode.TIMED && (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mt: 2}}>
          <Timer color="primary" />
          <Typography variant="body2" color="primary">
            Session Time: {Math.floor(totalTimeRemaining / 60)}:{(totalTimeRemaining % 60).toString().padStart(2, '0')}
          </Typography>
        </Box>
      )}
    </Paper>
  );
}
